import React, { Component } from "react";
import { Icon, Card } from "antd";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import StatBox from "../../../../components/stat-box";
// const today = new Date();

class VirtualOnboardStats extends Component {
  state = {
    loading: true,
    period: this.props.period,
    start_date: this.props.start_date,
    end_date: this.props.end_date,
    vo_stats: {},
  };
  componentDidMount() {
    this.loadStats();
  }
  componentDidUpdate() {
    let { period, start_date, end_date } = this.props;

    if (
      period !== this.state.period ||
      start_date !== this.state.start_date ||
      end_date !== this.state.end_date
    ) {
      this.setState(
        {
          period,
          start_date,
          end_date,
        },
        () => {
          this.loadStats();
        }
      );
    }
  }
  loadStats = () => {
    let { period, start_date, end_date } = this.props;

    // if (period === "all_bfiles") {
    //   const today = new Date();
    //   start_date = new Date("2010-01-01");
    //   end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    // }

    let data = {};
    if (this.props.agency_id === null) {
      data.all_agency = true;
      data.agency_id = null;
    } else {
      data.all_agency = false;
      data.agency_id = this.props.agency_id;
    }

    // let data = {};
    // if (this.props.agency_id === null) {
    //   data.from = moment(start_date).format("YYYY-MM-DD");
    //   data.to = moment(end_date).format("YYYY-MM-DD");
    //   data.all_agency = true;
    //   data.agency_id = this.props.agency_id;
    // } else {
    //   data.from = moment(start_date).format("YYYY-MM-DD");
    //   data.to = moment(end_date).format("YYYY-MM-DD");
    //   data.all_agency = false;
    //   data.agency_id = this.props.agency_id;
    // }

    data.from =
      period === "all_bfiles"
        ? moment(new Date("2010-01-01")).format("YYYY-MM-DD")
        : start_date;
    data.to =
      period === "all_bfiles"
        ? moment(new Date("2050-01-01")).format("YYYY-MM-DD")
        : end_date;

    // old condition
    // const route = this.props.user.type === "SUPER_ADMIN"
    // ? "/api/ea_vo_stats"
    // : "/api/am_vo_stats"

    // new condition
    const route =
      this.props.user.user_type &&
      this.props.user.user_type === "AGENCY_MANAGER"
        ? "/api/am_vo_stats"
        : "/api/ea_vo_stats";

    // old payload
    // const payload =
    // this.props.user.type === "SUPER_ADMIN"
    //       ? {
    //           from: moment(start_date).format("YYYY-MM-DD"),
    //           to: moment(end_date).format("YYYY-MM-DD"),
    //         }
    //       : data

    // F.log('LSP => API Route => User Type =>', this.props.user.user_type)
    // F.log('LSP => API Route =>', route)

    axios.post(route, data).then((res) => {
      this.setState({ vo_stats: res.data, loading: false });
    });
  };
  render() {
    const { period, start_date, end_date, user } = this.props;
    const { vo_stats, loading } = this.state;

    let date_url = "";
    // if (period === "from_to") {
    //   date_url =
    //     "/all/" +
    //     encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
    //     "/" +
    //     encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    // }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={
            <div>
              <Icon
                type="appstore"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Virtual Follow-Up Stats (Completed)`} />
            </div>
          }
          bordered={false}
          className="statsDetails"
        >
          <div className="statsGrid">
            <Card bordered={false} loading={loading}>
              <StatBox
                title="Customers Uploaded"
                val={vo_stats.count|| 0}
                color={"yellow"}
                link={"/bfiles/von-calls-made" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
              />
              <StatBox
                title="Scheduled Appointments For Follow Up"
                val={vo_stats.total_sent_to_efs || 0}
                color={"red"}
                link={"/bfiles/vo-sent-to-financial" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
              />
              <StatBox
                title="Not Interested"
                val={vo_stats.not_interested || 0}
                color={"green"}
                link={"/bfiles/vo-not-interested" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
              />
            </Card>
          </div>
        </Card>
      </div>
    );
  }
}

export default VirtualOnboardStats;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/lsp/virtual-onboard-stats.js